import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Datenschutz = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-black text-white">
        <Navbar />
      </div>
      <div className="bg-gray-50 flex-grow">
        <div className="container mx-auto px-6 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <h1 className="text-3xl font-bold mb-8">Datenschutzerklärung von <strong>benefitwerk.de</strong></h1>
            
            <p className="mb-4">Diese Anwendung erhebt personenbezogene Daten von ihren Nutzern.</p>
            <p className="mb-4">Dieses Dokument kann zu Zwecken der Aufbewahrung über den Befehl „Drucken" im Browser ausgedruckt werden.</p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Anbieter und Verantwortlicher</h2>
              <p className="mb-4">
                BenefitWerk<br />
                Eyachstraße 37, 71065 Sindelfingen
              </p>
              <p className="mb-4">
                <strong>E-Mail-Adresse des Anbieters:</strong> info@benefitwerk.de
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Arten der erhobenen Daten</h2>
              <p className="mb-4">
                Zu den personenbezogenen Daten, die diese Anwendung selbstständig oder durch Dritte verarbeitet, gehören: Nutzungsdaten; Tracker.
              </p>
              <p className="mb-4">
                Vollständige Details zu jeder Art von verarbeiteten personenbezogenen Daten werden in den dafür vorgesehenen Abschnitten dieser Datenschutzerklärung oder punktuell durch Erklärungstexte bereitgestellt.<br />
                Personenbezogene Daten können vom Nutzer freiwillig angegeben oder, im Falle von Nutzungsdaten, automatisch erhoben werden, wenn diese Anwendung genutzt wird.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Art und Ort der Datenverarbeitung</h2>
              <h3 className="text-xl font-semibold mb-3">Verarbeitungsmethoden</h3>
              <p className="mb-4">
                Der Anbieter verarbeitet die personenbezogenen Daten der Nutzer auf ordnungsgemäße Weise und ergreift angemessene Sicherheitsmaßnahmen, um den unbefugten Zugriff und die unbefugte Weiterleitung, Veränderung oder Vernichtung von Daten zu vermeiden.
              </p>
              <h3 className="text-xl font-semibold mb-3">Ort</h3>
              <p className="mb-4">
                Die Daten werden in der Betriebsstätte des Anbieters und an allen anderen Orten, an denen sich die an der Datenverarbeitung beteiligten Stellen befinden, verarbeitet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Cookie-Richtlinie</h2>
              <p className="mb-4">
                Diese Anwendung verwendet Tracker. Weitere Informationen ergeben sich aus der{' '}
                <a 
                  href="https://www.iubenda.com/privacy-policy/82265988/cookie-policy?ifr=true&height=685&newmarkup=no" 
                  className="text-blue-600 hover:text-blue-800 underline"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Cookie-Richtlinie
                </a>
                .
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Weitere Informationen für Nutzer</h2>
              <h3 className="text-xl font-semibold mb-3">Rechtsgrundlagen der Verarbeitung</h3>
              <p className="mb-4">
                Der Anbieter darf personenbezogene Daten von Nutzern nur dann verarbeiten, wenn einer der folgenden Punkte zutrifft:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Die Nutzer haben ihre Einwilligung für einen oder mehrere bestimmte Zwecke erteilt</li>
                <li>Die Datenerhebung ist für die Erfüllung eines Vertrags mit dem Nutzer und/oder für vorvertragliche Maßnahmen daraus erforderlich</li>
                <li>Die Verarbeitung ist für die Erfüllung einer rechtlichen Verpflichtung erforderlich</li>
                <li>Die Verarbeitung steht im Zusammenhang mit einer Aufgabe, die im öffentlichen Interesse liegt</li>
                <li>Die Verarbeitung ist zur Wahrung der berechtigten Interessen des Anbieters erforderlich</li>
              </ul>
            </section>

            <p className="text-sm text-gray-600 mt-8">
              Letzte Aktualisierung: 4. Februar 2025
            </p>

            <p className="text-sm text-gray-600 mt-4">
              <a 
                href="https://www.iubenda.com/de/generator-fuer-datenschutz-und-cookie-richtlinien" 
                className="text-blue-600 hover:text-blue-800 underline"
                target="_blank" 
                rel="noopener noreferrer"
              >
                iubenda
              </a> hostet diese Inhalte und stellt nur{' '}
              <a 
                href="https://www.iubenda.com/privacy-policy/45483222"
                className="text-blue-600 hover:text-blue-800 underline"
                target="_blank" 
                rel="noopener noreferrer"
              >
                die zu stellen
              </a>.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Datenschutz;